module.exports = __webpack_public_path__ + "img/tip.53379782.svg";